<template>
    <div class='check'>
        <div class="check_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li>訂單搜尋頁</li>
                </ul>
            </nav>
        </div>
        <!-- <div class="check_content">
            <div class="check_ib">
                <input type="text" placeholder="請輸入查詢的訂單編號" v-model="order_number">
                <button @click="check_order">查詢</button>
            </div>
        </div> -->
        <div class='container'>
            <div class="check_order">

                <div class="title">
                    <i class="icon-new_order mr-5"></i>
                    <span>訂單查詢</span>
                </div>
                <div class="check">
                    <div class="check_flex">
                        <input @keyup.enter="keyDown($event)" type="text" v-model="value" placeholder="請輸入訂單號">
                        <div class="search" @click="keyDown($event)">查詢</div>
                    </div>
                </div>
            </div>
            <div class="check_order">

                <div class="title">
                    <i class="icon-new_order mr-5"></i>
                    <span>手機號查詢訂單號</span>
                </div>
                <div class="check">
                    <div class="check_flex">
                        <input @keyup.enter="keyDownPhone($event)" type="text" v-model="phone_number" placeholder="請輸入手機號">
                        <div class="search" @click="keyDownPhone($event)">查詢</div>
                    </div>
                    <div v-if="see_order_number">
                        <ul style="list-style-type: none; padding: 10px 0px 0px; font-size: 20px;" v-if="this.judgment">
                            查詢到的訂單號:
                            <li v-for="item, index in  order_number">{{ index + 1 }}. {{ item }}</li>
                        </ul>
                        <ul style="list-style-type: none; text-align: center; padding: 10px 0px 0px; font-size: 20px;"
                            v-else>
                            該手機號暫無訂單
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <Navbar></Navbar>
    </div>
</template>
<script>
import Navbar from '@/components/navbar/index.vue'
import { mapState } from 'vuex';
export default {
    components: {
        Navbar
    },
    data() {
        return {
            // order_number: '',
            value: '',
            phone_number: '',
            order_number: [],
            judgment: false,
            see_order_number: false,
            webmeta: {
                og_title: '',
                check_title: '',
                check_description: ''
            }
        };
    },
    computed: {
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
        computedOgTitle() {
            return this.seo.og_title || '';
        },
        computedTitle() {
            return this.seo.check_title || '';
        },
        computedDescription() {
            return this.seo.check_description || '';
        }
    },
    watch: {},
    methods: {
        check_order() {
            this.$store.dispatch('order/payment_two', { data: this.order_number }).then((e) => {
                if (e) {
                    this.$router.push({ path: `order/${this.order_number}` })
                } else {
                    this.$notify({
                        title: '查無此單',
                        type: 'error'
                    });
                }
            })
        },
        keyDown(e) {
            if (this.value === null || this.value === undefined || this.value === '') {
                return
            } else {
                let value = this.value
                this.$router.push({
                    path: `/order/${value}`
                }).catch(err => { })
            }
        },
        keyDownPhone(e) {
            if (this.phone_number === null || this.phone_number === undefined || this.phone_number === '') {
                return
            } else {

                this.order_number = [];
                this.$store.dispatch('order/payment_two', { data: this.phone_number, phone: 'phone' }).then((e_state) => {
                    // console.log(this.$store.getters['order/order']);

                    if (e_state == false) {
                        this.judgment = false
                    } else {
                        this.judgment = true;
                        this.$store.getters['order/order'].forEach((e) => {
                            this.order_number.push(e.order.order_num);
                        });
                    }

                    if (this.$store.getters['order/order'].length == 0) {
                        this.judgment = false;
                    }
                    this.see_order_number = true;

                    // console.log(this.order_number);
                });
            }

        }
    },
    created() {
    },
    mounted() {
    },
}
</script>
<style src="./index.scss" lang='scss' scoped></style>